module.exports = __webpack_public_path__ + "img/profile-demographic-active.ac069e2e.svg";